/**
 * ★ F262(사장님 2026-08-08): 문서 아이콘 업로드 — dox_form.html 의 아이콘
 *   칸을 배선한다.
 *
 * 왜 **위임**인가 — 문서 이름 폼은 nx.modal 이 fetch 로 받아 **나중에**
 * DOM 에 끼워 넣는다. 조각 안 <script> 는 innerHTML 로는 실행되지 않으므로
 * (표준 동작), 부팅 때 document 에 한 번 걸어 두고 id 로 알아본다 —
 * doxtree 의 토글 위임과 같은 이유다.
 *
 * 흐름(에디터 본문 이미지와 같은 틀 — dox_content_asset 참고):
 *   ① 파일 선택 → POST /my/dox/<id>/icon {content_type, bytes} → presigned
 *   ② 그 url/fields 로 S3 에 multipart POST (진짜 상한은 POST 정책이 강제)
 *   ③ 성공하면 hidden input(name=icon)에 서버가 정한 파일 이름을 싣는다 —
 *      [저장] 을 눌러야 DB 에 앉는다(폼을 닫으면 그냥 고아 파일, 청소 정책은
 *      본문 이미지와 같다: 지우지 않는다).
 *   ④ [기본 아이콘] 은 icon="-" — 서버가 NULL 로 되돌린다.
 *
 * 모든 실패는 이 칸 안의 오류 줄에만 적는다 — 이름 저장 자체를 막지 않는다.
 */

const TYPES = ['image/png', 'image/jpeg', 'image/webp'];

function $id(id: string): HTMLElement | null {
  return document.getElementById(id);
}

function err(msg: string): void {
  const e = $id('dox-icon-err');
  if (!e) return;
  e.textContent = msg;
  e.hidden = !msg;
}

function showPreview(src: string | null): void {
  const view = $id('dox-icon-view');
  if (!view) return;
  if (src) {
    const box = view.querySelector('.nx-dox-ico');
    if (!box) return;
    box.innerHTML = '';
    const img = document.createElement('img');
    img.src = src;
    img.alt = '';
    box.appendChild(img);
  } else {
    // ★★ F463(사장님 2026-08-16): 기본 마크로 되돌린다. **마크업을 짓지
    //   않는다** — 서버가 같은 매크로로 그려 둔 <template> 조각을 복제해
    //   끼운다(F221: 두 벌 금지). 조각이 없으면(옛 판 화면) 그냥 둔다.
    const tpl = $id('dox-icon-default') as HTMLTemplateElement | null;
    if (tpl && 'content' in tpl) view.replaceChildren(tpl.content.cloneNode(true));
  }
  const reset = $id('dox-icon-reset');
  if (reset) reset.hidden = !src;
}

async function upload(file: File): Promise<void> {
  const box = $id('dox-icon-box');
  const val = $id('dox-icon-val') as HTMLInputElement | null;
  if (!box || !val) return;
  err('');
  if (!TYPES.includes(file.type)) { err(box.dataset.errType || '!'); return; }

  // presigned 발급 — 상한 초과는 서버가 413 으로 알려 준다(문구는 여기 것).
  const r = await fetch(box.dataset.iconPath || '', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(window.nx?.csrfHeaders() || {}) },
    credentials: 'same-origin',
    body: JSON.stringify({ content_type: file.type, bytes: file.size }),
  });
  if (r.status === 413) { err(box.dataset.errBig || '!'); return; }
  if (!r.ok) { err(box.dataset.errType || '!'); return; }
  const post = await r.json();

  const fd = new FormData();
  for (const [k, v] of Object.entries(post.fields || {})) fd.append(k, String(v));
  fd.append('file', file);
  const up = await fetch(post.url, { method: 'POST', body: fd });
  if (!up.ok) { err(box.dataset.errBig || '!'); return; }

  val.value = String(post.name || '');
  // 미리보기는 로컬 파일로 — presigned GET 왕복 없이 즉시 보인다.
  showPreview(URL.createObjectURL(file));
}

export function initDoxIcon(): void {
  document.addEventListener('click', (ev: Event) => {
    const t = ev.target as HTMLElement | null;
    if (!t) return;
    if (t.closest('#dox-icon-pick')) {
      ($id('dox-icon-file') as HTMLInputElement | null)?.click();
    } else if (t.closest('#dox-icon-reset')) {
      const val = $id('dox-icon-val') as HTMLInputElement | null;
      if (val) val.value = '-';
      err('');
      // ★★ F463(사장님 2026-08-16): **미리보기도 기본 마크로 되돌린다.**
      //   버튼만 숨기던 옛 판은 «눌렀는데 그림이 그대로» 라 아무 일도 안 한
      //   것처럼 보였다. showPreview(null) 이 버튼 숨김까지 같이 한다.
      showPreview(null);
    }
  }, true);

  document.addEventListener('change', (ev: Event) => {
    const t = ev.target as HTMLInputElement | null;
    if (!t || t.id !== 'dox-icon-file') return;
    const f = t.files && t.files[0];
    if (f) void upload(f).catch(() => err('!'));
    t.value = '';   // 같은 파일을 다시 골라도 change 가 다시 온다
  }, true);
}
